import { RecordingPageGridDataSource } from './RecordingPageGridDataSource';
import { CmsProperty } from '../../api/models/Shared.types';
import { Log } from '@lightningjs/sdk';
import { SettingsKeys } from '../../api/models/TranslationKeys';
import { mapToRecordingPageType } from '../utility/PageTypeUtil';
import { recordingPageTypeToAnalytics } from '../../api/analytics/AnalyticsUtil';
import { Backend } from '../../api/Backend';
import { ChannelModel } from '../../api/EpgApi.types';
import { RecordingPageTypes } from '../../api/user/RecordingApi.types';
import { GridDataSource } from '../cms/GridDataSource';

export class RecordingPageDataSource {
  private _channels: ChannelModel[] | undefined;
  private backend: Backend;
  private menuPageType: string;
  private recPageType: RecordingPageTypes | undefined;
  constructor(backend: Backend, menuPageType: string, channels: ChannelModel[] | undefined = undefined) {
    this.backend = backend;
    this.menuPageType = menuPageType;
    this._channels = channels;
    this.recPageType = mapToRecordingPageType(this.menuPageType);
  }

  set channels(_channels: ChannelModel[]) {
    this._channels = _channels;
  }

  getRecordingContent(): Promise<GridDataSource | undefined> {
    if (!this.recPageType) {
      Log.error(`${this.menuPageType} is not supported for recordings page`);
      return Promise.resolve(undefined);
    }
    if (!this._channels) {
      Log.error('channels is not yet set for recordings page');
      return Promise.resolve(undefined);
    }
    const ds = new RecordingPageGridDataSource(
      this.backend,
      this._channels,
      this.recPageType,
      this.pageProperties as CmsProperty[]
    );
    return ds.load();
  }

  get pageProperties() {
    let properties;
    properties = this.backend.globalSettings.stringArray(SettingsKeys.propertiesRecordingsRibbon);
    properties = properties
      ? properties
      : [CmsProperty.ShowProgress, CmsProperty.UseBestSchedule, CmsProperty.ShowScheduleInfo];
    return properties;
  }

  logPageView(backend: Backend, title: string) {
    backend.logService.trackPageView(recordingPageTypeToAnalytics(this.menuPageType) || 'undefined', title);
  }
}
